{
  "common": {
    "px": "px",
    "px_uppercase": "PX",
    "seconds": "segundos",
    "other": "-- Outro --",
    "customFieldExistsError": "O campo personalizado com este nome já existe",
    "uniqueKeyNotUniqueError": "Este Chave não é único",
    "save": "Salvar",
    "saving": "Salvando",
    "typeAnOption": "Digite uma opção",
    "unsaved": "Não salvo",
    "noSubmissionsFound": "Nenhum envio encontrado",
    "sortBy": "Ordenar por",
    "clearAll": "Limpar tudo",
    "submitSurvey": "Enviar pesquisa",
    "select": "Selecionar",
    "data"  : "dados",
    "disqualifyAfterSubmitLower": "Desqualificar após o envio",
    "errorRetryAgain": "Erro, tente novamente",
    "bubbleRadioStyleImageAlt": "Estilo de botão em forma de bolha",
    "standardRadioStyleImageAlt": "Estilo padrão do botão de opção",
    "recurringFrequency": {
      "once": "Uma vez",
      "daily": "Diariamente",
      "weekly": "Semanalmente",
      "monthly": "Mensalmente",
      "yearly": "Anualmente"
    },
    "yes": "Sim",
    "no": "Não",
    "updated": "Atualizado",
    "new": "Novo",
    "title": "Título",
    "openSettings": "Abrir as configurações",
    "cloneField": "Clonar campo",
    "removeField": "Remover campo",
    "description": "Descrição",
    "cannotAddThisField": "Você não pode adicionar este campo",
    "overallOnly": "Somente geral",
    "nextSlideDefault": "Próximo Slide (Padrão)",
    "nextQuestion": "Próxima Pergunta",
    "searchAddress": "Pesquisar endereço",
    "recurringDonation": "Doação Recorrente",
    "recurringDonationDay": "Doação recorrente de 1 dia",
    "recurringDonationWeek": "Doação Recorrente 1 vez por semana",
    "recurringDonationMonth": "Doação recorrente de 1 mês",
    "recurringDonationYear": "Doação Recorrente de 1 Ano",
    "integrate": "Integrar",
    "preview": "Pré-visualizar",
    "back": "Voltar",
    "alert": "Alerta",
    "proceed": "Prosseguir",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "embed": "Incorporar",
    "link": "Link",
    "linkModal": {
      "title": "Inserir link",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.exemplo.com",
      "invalidUrl": "O URL é inválido"
    },
    "iframeEmbed": "Incorporação de iframe",
    "styles": "Estilos",
    "options": "Opções",
    "quickAdd": "Adição rápida",
    "customFields": "Campos personalizados",
    "addObjectFields": "Adicionar campos de objeto",
    "personalInfo": "Informações pessoais",
    "contactInfo": "Informações de contato",
    "submit": "Enviar",
    "address": "Endereço",
    "customized": "Personalizado",
    "layout": "Layout",
    "showLabel": "Mostrar rótulo",
    "showImage" : "Exibir imagem",
    "imageLayout" : "Layout da imagem",
    "imageLayoutSettings" : "Configurações de layout de imagem",
    "imageLayoutMode" : "Modo de layout da imagem",
    "surveyDefault" : "Pesquisa Padrão",
    "independent" : "Independente",
    "image" : "Imagem",
    "desktop" : "Desktop",
    "mobile" : "Móvel",
    "desktopImage" : "Imagem para desktop",
    "mobileImage" : "Imagem de celular",
    "uploaded" : "Carregado",
    "changeImage" : "Alterar Imagem",
    "uploadImage" : "Carregar imagem",
    "remove" : "Remover",
    "background": "Plano de fundo",
    "buttonBackground": "Plano de fundo do Botão",
    "fontColour": "Cor da fonte",
    "textFontColour": "Cor da fonte do texto",
    "subTextFontColour": "Cor da fonte do subtexto",
    "selectThemes": "Selecionar tema",
    "selectOne": "Selecione um(a)",
    "enableIcon": "Ativar Ícone",
    "iconType": "Tipo de ícone",
    "iconPlacement": "Posicionamento do ícone",
    "filled": "Preenchido",
    "textOnly": "Apenas o corpo",
    "border": "Borda",
    "borderType": "Tipo de borda",
    "cornerRadius": "Raio do canto",
    "width": "Largura",
    "padding": "Espaçamento",
    "top": "Principal",
    "bottom": "Parte inferior",
    "left": "Esquerda",
    "right": "Direita",
    "center": "Centro",
    "default": "Padrão",
    "formDefault": "Padrão do formulário",
    "shadow": "Sombra",
    "color": "Cor",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "blur": "Desfoque",
    "spread": "Difusão",
    "fieldStyle": "Estilo do campo",
    "fontColor": "Cor da fonte",
    "inputTextFillColor": "Cor de preenchimento do texto de entrada",
    "inputTextColor": "Cor do texto de entrada",
    "primaryColor": "Cor principal",
    "primaryColorTooltip": "Controla a Cor para o estado de foco e o estado Dinâmico.",
    "inputTextColorTooltip": "Controla a Cor do Texto digitado nos campos de feedback.",
    "mapPrimaryColorToButtonColor": "Mapear a cor primária do mapa para a cor do botão",
    "label": "Rótulo",
    "fontFamily": "Família de fontes",
    "size": "Tamanho",
    "weight": "Peso",
    "fontWeightTooltip": "Aplicável no caso de parágrafos",
    "fontWeightOptions": {
      "thin": "100 - Fino",
      "extraLight": "200 - Extra Leve",
      "light": "300 - Leve",
      "normal": "400 - Normal",
      "medium": "500 - Médio",
      "semiBold": "600 - Semi-negrito",
      "bold": "700 - Negrito"
    },
    "placeholder" : "Placeholder",
    "customCSS" : "CSS personalizado",
    "backgroundImage" : "Imagem de fundo",
    "headerImage" : "Imagem do cabeçalho",
    "miscellaneous" : "Diversos",
    "agencyBranding" : "Branding da agência",
    "imageUploadMessage" : "Clique ou arraste um arquivo de imagem para esta área para carregar",
    "backgroundImageTooltipMessage" : "A imagem de fundo deve cobrir toda a página, criando um pano de fundo visualmente atraente para o formulário. Para ver a imagem de fundo, clique na opção Pré-visualizar.",
    "headerImageTooltipMessage" : "A imagem do cabeçalho foi projetada para cobrir toda a largura do formulário e permanece posicionada na parte superior do formulário. Para ver a imagem do cabeçalho, clique na opção Pré-visualizar.",
    "onSubmit" : "Ao enviar",
    "facebookPixelID" : "ID do pixel do Facebook",
    "facebookPixelIDMessage" : "Ignore este campo se você planeja usar este formulário/pesquisa dentro de um funil",
    "facebookPixelEvents" : "Eventos do pixel do Facebook",
    "onpageView" : "Exibição na página",
    "stickyContact" : "Contato importante",
    "stickyContactMessage" : "Lembra e preenche automaticamente os detalhes de contato quando o usuário retorna no mesmo dispositivo e navegador.",
    "fieldDescription" : "Descrição do campo",
    "fieldTitle" : "Título do campo",
    "queryKey" : "Chave de consulta",
    "querykeyTooltipMessage" : "A chave de consulta que pode ser usada como um parâmetro de URL para preencher este campo",
    "required" : "Obrigatório",
    "hidden" : "Oculto",
    "hiddenValue" : "Valor oculto",
    "enableCountryPicker" : "Ativar seletor de países",
    "altText" : "Texto alternativo",
    "optionImageAlt" : "Option image",
    "bannerAlt" : "banner",
    "avatarAlt" : "Avatar Name",
    "alignment" : "Alinhamento",
    "imageWidth" : "Largura da imagem",
    "imageHeight" : "Altura da imagem",
    "logic" : "Lógica",
    "pleaseInput" : "Insira",
    "editHTML" : "Editar HTML",
    "textStyle" : "Estilo de texto",
    "subText" : "Subtítulo",
    "text" : "Texto",
    "buttonStyle" : "Estilo do botão",
    "fullWidth" : "Largura total",
    "htmlMessage" : "O HTML personalizado vai aqui",
    "htmlEditorHeader" : "JAVASCRIPT / HTML PERSONALIZADO",
    "htmlEditorBodyMessage" : "Adicione seu código aqui",
    "scriptAdded" : "Script Added!",
    "sourceAdded" : "Source Added!",
    "yesSave" : "Sim, salvar",
    "cancelKeep" : "Cancelar, Manter",
    "done" : "Concluído",
    "addElement" : "Adicionar elemento",
    "addUrlLike" : "Por favor, inclua URLs válidas, como:",
    "doNotAddRelativePath" : "Não adicione caminhos relativos como",
    "or" : "ou",
    "addCustomFields" : "Adicionar campos personalizados",
    "customFieldSearch" : "Pesquisar por nome",
    "enterSourceValue" : "Insira o valor de origem",
    "shortLabel" : "Rótulo curto",
    "shortLabelPlaceholder" : "Fonte a rótulo curto",
    "labelPlaceholder" : "Digitar um rótulo",
    "fileUploadPlaceholder" : "Carregar um arquivo",
    "imagePlaceholder" : "Image",
    "fillValuesPlaceholder" : "Preencha os valores",
    "customCSSTooltip" : "O CSS personalizado tem precedência sobre o estilo e os temas do formulário e pode afetar o estilo do tema.",
    "fontFamilyTooltip" : "O construtor é compatível com todos os tipos de fontes, caso você não consiga ver isso na lista. Pesquise no menu suspenso",
    "useGDPRCompliantFont" : "Use uma fonte compatível com GDPR",
    "enableTimezone" : "Ativar fuso horário",
    "inputStyle" : "Estilo de entrada",
    "conditionalLogicAlertOnSubmit" : "A lógica condicional terá precedência sobre a mensagem/ redirecionamento aqui",
    "conditionalLogicAlertOnShowHide" : "A lógica condicional terá precedência sobre as configurações ocultas aqui",
    "placeholderFacebookPixelIdInput" : "Insira o ID do pixel do Facebook",
    "doNotShowMessage" : "Não exibir novamente",
    "creatingForm" : "Crie seu formulário...",
    "creatingSurvey" : "Criado sua pesquisa...",
    "creatingQuiz" : "Crie seu questionário...",
    "errorCreatingForm" : "Lá foi um erro Criado seu formulário. Tente de novo.",
    "errorCreatingSurvey" : "Lá foi um erro Criado sua pesquisa. Tente de novo.",
    "errorCreatingQuiz" : "Lá foi um erro Criado seu questionário. Tente de novo.",
    "redirectMessage" : "Você será redirecionado para:",
    "themes" : {
      "themes" : "Temas",
      "alertThemeMessage" : "A troca de temas resultará na perda de todas as modificações de estilo atuais.",
      "useTheme" : "Usar tema",
      "removeTheme" : "Remover tema"
    },
    "box" : "Caixa",
    "line" : "Linha",
    "message" : "Mensagem",
    "openUrl" : "Redirecionar para URL",
    "borderTypeList" : {
      "dotted" : "Pontilhado",
      "dashed" : "Tracejado",
      "solid" : "Sólido",
      "none" : "Nenhum"
    },
    "button" : "Botão",
    "emailNotification" : "Notificação por e-mail",
    "emailNotificationSubheader" : "Receba um e-mail quando alguém preencher seu formulário",
    "subject" : "Assunto",
    "emailTo" : "E-mail (Para)",
    "senderName" : "Nome do remetente",
    "senderNameWarning" : "Seu (nome da subconta) será adicionado se deixado em branco",
    "emailError" : "Pelo menos um endereço de e-mail é necessário",
    "emailTooltip" : "O primeiro endereço de e-mail é designado para o campo \"Para\". Todos os endereços de e-mail subsequentes serão incluídos no campo \"Cc\".",
    "clear" : "Limpar",
    "filter" : "Filtrar",
    "noResults" : "Nenhum resultado",
    "search" : "Pesquisar",
    "showNotificationsSettings" : "Exibir configurações de notificações",
    "emailServicePaid" : "Este recurso é um serviço pago e será cobrado com base em seu uso.",
    "integration" : "Integração",
    "validation" : {
      "fieldRequired" : "O campo é obrigatório",
      "maxLengthExceeded" : "Comprimento máximo excedido ({max} Caractere)"
    },
    "securityValidation": {
      "title":"Security issues detected. The following are not allowed:",
      "cookieAccess": "Cookie access detected (document.cookie). This is not allowed for security reasons.",
      "storageAccess": "localStorage.getItem() - reading from localStorage is not allowed.",
      "evalUsage": "Use of eval() is not allowed as it can execute arbitrary code.",
      "dynamicFunction": "Dynamic function creation (new Function) is not allowed for security reasons.",
      "stringExecution": "Passing strings to setTimeout/setInterval is not allowed as it can execute arbitrary code. Use function references instead."
    },
    "products": {
      "subscriptionBadge": "Assinatura",
      "trialBadge": "{days} dias de teste gratuito",
      "setupFee": "Taxa de configuração única",
      "quantity": "Quantidade",
      "productImageAlt": "Imagem do produto",
      "bumpIconAlt": "Ícone de opção adicional"
    },
    "payment" : {
      "payments" : "Pagamentos",
      "connected" : "Conectado",
      "connect" : "Conectar",
      "liveModeOn" : "Modo ao vivo",
      "status" : "Status",
      "test" : "Testar",
      "live" : "Ao vivo",
      "paymentFields" : "Campos de pagamento",
      "suggestAnAmount" : "Sugira uma quantidade",
      "recurringPayments" : "Pagamentos Recorrentes",
      "selectCurrency" : "Selecione a moeda",
      "tagActiveBGColor" : "Cor da etiqueta ativa",
      "includeOtherAmount" : "Incluir outro valor",
      "footerInfo" : "Informações do rodapé",
      "paymentType" : "Tipo de pagamento",
      "sellProducts" : "Vender produtos",
      "customAmount" : "Valor personalizado",
      "collectPayment" : "Cobrar pagamento",
      "generalSettings" : "Campos gerais",
      "securePayments" : "*100% Bloquear e pagamentos seguros*",
      "error" : {
        "addMainProductFirst" : "Adicionar um produto PRINCIPAL primeiro",
        "priceNotFoundForBumpProduct" : "Preço não encontrado para o Produto adicional",
        "productAlreadyAdded" : "Produto já adicionado"
      },
      "product" : {
        "addProduct" : "Adicionar produto",
        "productSettings" : "Configurações do produto",
        "bumpTag" : "Bump",
        "settingsAria" : "Configurações do produto",
        "deleteAria" : "Excluir produto",
        "selectProduct" : "Selecione o produto",
        "editThisProduct" : "Para editar este produto",
        "clickHere" : "Clique aqui",
        "show" : "Exibir",
        "description" : "Descrição",
        "image" : "Imagem",
        "layoutSettings" : "Configurações de layout",
        "singleColumn" : "Coluna única",
        "twoColumn" : "Duas colunas",
        "threeColumn" : "Três colunas",
        "maxProductError" : "São permitidos no máximo 20 produtos em um formulário",
        "productSelectPlaceholder" : "Selecione um produto",
        "orderConfirmation" : "Confirmação do pedido",
        "orderConfirmationWarning" : "Uma página de confirmação do pedido será exibida assim que o pagamento for bem-sucedido",
        "quantity" : "Quantidade",
        "createProduct" : "Para criar um produto",
        "noProductsAdded" : "Nenhum produto adicionado ainda",
        "productsWillShowHere" : "Depois de Você Incluir produtos, eles exibirão Direita aqui",
        "chooseProductType" : "Selecionar produto digital",
        "mainProduct" : "PRINCIPAL Produto"
      },
      "bumProduct" : {
        "price" : "Preço",
        "variant" : "Variante",
        "headline" : "Título",
        "otoHeadline" : "Título OTO",
        "otoText" : "OTO Corpo",
        "enableImage" : "Habilitar Imagem",
        "imageMessage" : "Obteremos a imagem do padrão produto",
        "orUploadADifferentImage" : "Ou carregar uma imagem diferente",
        "bumpProducts" : "Produtos adicionais",
        "bumpProduct" : "Produto adicional",
        "enableBump" : "Habilitar Bump",
        "orderBumpStyle" : "Estilo Oferta adicional",
        "classic" : "Clássico",
        "modern" : "Recente",
        "icon" : "Ícone",
        "bumpTemplate" : "Selecionar Modelo",
        "highlightText" : "Destacar Corpo",
        "showPrice" : "Exibir Preço",
        "bumpPriceColor" : "Preço adicional",
        "bumpIconColor" : "Ícone de Bump",
        "bumpBackgroundColor" : "Plano de fundo do Bump",
        "highlightTextColor" : "Destacar Corpo",
        "headlineColor" : "Título",
        "otoHeadlineColor" : "Título OTO",
        "otoTextColor" : "OTO Corpo",
        "bumpBorderColor" : "Borda adicional",
        "priceRequired" : "O preço é obrigatório",
        "headlineRequired" : "O título é obrigatório",
        "otoHeadlineRequired" : "O título OTO é obrigatório",
        "otoTextRequired" : "O texto OTO é obrigatório",
        "bumpProductTooltip" : "Um pequeno Complemento oferecido durante a Finalização da compra para a Multiplicar Ordenar Valor. Os clientes podem incluir um Indivíduo clicar.",
        "templateOne" : "Modelo 1",
        "templateTwo" : "Modelo 2",
        "templateThree" : "Modelo 3",
        "animationIcon" : {
          "none" : "Nenhum",
          "arrow" : "Seta",
          "fire" : "Dispara",
          "plus" : "Mais",
          "giftBox" : "Caixa de presente",
          "timer" : "Contagem regressiva",
          "cracker" : "cookies",
          "snack" : "Mesclar",
          "partyBalloon" : "Balão de data",
          "flash" : "Instantâneo",
          "money" : "Moeda",
          "spaceShuttle" : "Transferir Espaço"
        }
      },
      "coupons" : {
        "coupons" : "Cupons",
        "enableCoupon" : "Ativar cupom",
        "couponAlignment" : "Alinhamento de cupom",
        "left" : "Esquerda",
        "right" : "Direita",
        "fullWidth" : "Largura total",
        "tooltipMessage" : "Defina a posição da entrada do cupom a partir dos tipos abaixo"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Endereço de preenchimento automático",
      "addressfields" : "Campos de endereço",
      "placeholderSearch" : "Pesquisar endereço",
      "autoCompleteTooltip" : "Oferece a capacidade de pesquisar e preencher endereços automaticamente.",
      "streetAddress" : "Endereço",
      "autoCompleteAddressTitle" : "Concluir endereço automaticamente",
      "newBadge" : "novo",
      "defaultLabel" : "Endereço",
      "searchPlaceholder" : "Pesquisar endereço",
      "mandataorySearch" : {
        "title" : "Obrigatório para selecionar o endereço in barra Pesquisar",
        "primaryText" : "Endereço automático somente para rua",
        "secondaryText" : "Quando Habilitado, Quando um usuário interagem com o Endereço Campo, Então eles devem selecionar um Endereço válido para Prosseguir.",
        "secondaryText1" : "Quando desabilitado Então, eles podem Prosseguir sem selecionar um endereço in barra Pesquisar."
      }
    },
    "autoResponder" : "Resposta automática",
    "autoResponderSubheader" : "Envie um e-mail automático para a pessoa que enviar o formulário (o e-mail inclui uma cópia das informações inseridas no formulário)",
    "replyToEmail" : "Responder ao e-mail",
    "open" : "Aberto(a)",
    "won" : "Ganho(a)",
    "lost" : "Perdido(a)",
    "abandon" : "Abandonar",
    "selectAPipeline" : "Selecione um pipeline",
    "stage" : "Fase",
    "status" : "Status",
    "opportunityValue" : "Valor da oportunidade",
    "createNewPipeline" : "Crie um novo pipeline",
    "editOpportunitySettings" : "Editar configurações de oportunidade",
    "contact" : "Contato",
    "opportunity" : "Oportunidade",
    "business" : "Empresa",
    "add" : "Adicionar",
    "more" : "Mais",
    "opportunityHeading" : "Onde você quer que sua oportunidade seja atualizada?",
    "date" : {
      "dateSettings" : "Configurações de data",
      "dateFormat" : "Formato de data",
      "dateSeparator" : "Separador de data",
      "dateFormatTooltipMessage" : "Selecione um formato de data. D significa dia, M significa meses e Y significa ano",
      "dateSeparatorTooltipMessage" : "Selecione um separador que separará o dia, o mês e o ano no formato selecionado em Formato da data",
      "disablePicker" : "Desativar seletor"
    },
    "restoreVersion" : "Restaurar versão",
    "versionHistory" : "Histórico da versão",
    "errorMessage" : "Erro, tente novamente",
    "version" : "Versão:",
    "currentVersion" : "Versão atual",
    "messageStyling" : "Estilo de Mensagens",
    "validateEmailHeader" : "Validar e-mail",
    "validateEmailDescription" : "O botão ficará visível quando o usuário inserir o e-mail. Este recurso foi criado para ajudar você a gerar leads de qualidade.",
    "verifyEmail" : "Verifique o e-mail",
    "validatePhoneHeader" : "Validar telefone",
    "validatePhoneDescription" : "O botão ficará visível quando o usuário inserir o telefone. Este recurso foi criado para ajudar você a gerar leads de qualidade.",
    "verifyPhone" : "Verificar telefone",
    "validatePhoneWarning" : "Para ativar a verificação OTP por SMS, certifique-se de que seu número de telefone esteja configurado nas configurações de localização",
    "addAnotherTnc" : "Adicione outro T & C",
    "tnc1" : "T & C 1",
    "tnc2" : "Termos e Condições 2",
    "deleteCaps" : "EXCLUIR",
    "deleteConfirmation" : "Digite EXCLUIR para confirmar",
    "marginPadding" : "Margem e espaçamento",
    "style" : {
      "formLayoutType" : "Tipo de formulário",
      "layoutType" : "Tipo de Layout",
      "surveyType" : "Tipo de Pesquisa",
      "oneColumn" : "Uma coluna",
      "twoColumn" : "Duas colunas",
      "singleLine" : "Linha única",
      "fieldWidth" : "Largura do campo",
      "labelAlignment" : {
        "labelAlignment" : "Alinhamento do rótulo",
        "labelWidth" : "Largura do rótulo"
      },
      "fieldSpacing" : "Espaçamento de campo",
      "imageFieldSpacing" : "Espaçamento de imagem e campo",
      "imageCornerRadius" : "Raio do canto da imagem",
      "color" : "cor",
      "fontColor" : "Cor da fonte",
      "inputBackgroundColor" : "Cor do plano fundo de entrada",
      "inputBorder" : "Borda de entrada",
      "layout" : "Layout",
      "colorsAndBackground" : "Cores & Plano de fundo",
      "imageLayout" : {
        "imageLayout" : "Layout da imagem",
        "showImage" : "Exibir imagem",
        "image" : "Imagem",
        "desktop" : {
          "topFixed" : "Superior fixo",
          "leftCenter" : "Central Esquerda",
          "rightCenter" : "Centro-direita",
          "leftFixed" : "Esquerda Fixo",
          "rightFixed" : "Fixo à direita",
          "background" : "Plano de fundo"
        },
        "mobile" : {
          "header" : "Cabeçalho",
          "background" : "Plano de fundo"
        }
      },
      "focusPoint" : {
        "title" : "Ponto Focal",
        "reset" : "Redefinir",
        "noImage" : "Nenhuma imagem carregada"
      },
      "advanceSettings" : "Configurações avançadas",
      "inputField" : "Campo de entrada",
      "borderWidth" : "Largura da borda",
      "borderColor" : "Cor da borda",
      "borderStyle" : "Estilo de borda",
      "fontSize" : "Tamanho da fonte",
      "fontWeight" : "Espessura da fonte",
      "labelColor" : "Cor da etiqueta",
      "placeholderColor" : "Cor do placeholder",
      "shortLabelColor" : "Cor do rótulo curto"
    },
    "replyToTooltip" : "Personalize o endereço de e-mail padrão para resposta usando {'{'}{'{'}contact.email{'}'}{'}'} para ativar respostas ao contato que envia o formulário.",
    "content" : "Conteúdo",
    "calculations" : "Cálculos",
    "uploadOptions" : "Opções de upload",
    "opportunitySettingsWarning" : "Defina as configurações de oportunidade clicando no botão Editar configurações de oportunidade.",
    "startValue" : "Valor de Início",
    "endValue" : "Valor Fim",
    "today" : "Hoje",
    "thisWeek" : "Esta semana",
    "last7Days" : "Últimos 7 dias",
    "thisMonth" : "Este mês",
    "last30Days" : "Últimos 30 dias",
    "question" : "Pergunta",
    "createContactOnPartialSubmission" : "Criar contato em envio parcial",
    "howItWorks" : "Como funciona?",
    "createContactOnPartialSubmissionDescription" : "Finalize o slide e clique em \"Avançar\". Um novo contato será criado e armazenado automaticamente.",
    "swapWarningMessageSurvey" : "A edição ou troca de opções afetará este campo personalizado em todos os locais em que o campo for usado. Também pode redefinir a lógica condicional. ",
    "swapWarningMessageForm" : "A edição ou troca de opções afetará este campo personalizado em todos os locais em que o campo for usado. ",
    "migrationWarningMessage" : "Esta funcionalidade foi migrada para a Lógica Condicional da Pesquisa.",
    "optionLabel" : "Rótulo de opção",
    "calculationValue" : "Valor de cálculo",
    "addOption" : "Adicionar opção",
    "enableCalculations" : "Ativar cálculos",
    "allowOtherOption" : "Permitir Outra Opção",
    "productSelectionSubtext" : "Habilitar Indivíduo ou seleção de vários produtos",
    "multi" : "Multi",
    "single" : "Individual",
    "productSelectionHeading" : "Seleção de Produto",
    "spreadToColumns" : "Espalhar em colunas",
    "columns" : "Colunas",
    "customstyle" : "Estilo",
    "standard" : "Padrão",
    "bubble" : "Bubble",
    "integratePopup" : {
      "title" : "Formulário de integração",
      "embedCode" : "Incorporar código",
      "useInFunnelOrEmbedCode" : "Usar no funil/código incorporado",
      "iframeEmbed" : "Incorporar de iframe",
      "layout" : {
        "title" : "Incorporar tipo de layout",
        "description" : "Selecione um layout para incorporar em um funil ou site externo",
        "allowMinimize" : "Permitir minimizar",
        "minimizedTitlePlaceholder" : "Título minimizado",
        "leftAlignAlt" : "Alinhar à esquerda",
        "rightAlignAlt" : "Alinhar à direita"
      },
      "triggerType" : "Tipo de gatilho",
      "triggers" : {
        "seconds" : "segundos"
      },
      "activation" : {
        "title" : "Opções de ativação",
        "visit" : "visitar"
      },
      "deactivation" : {
        "title" : "Opções de desativação",
        "times" : "vezes"
      },
      "copyEmbedCode" : "Copiar código de incorporação",
      "copyFormLink" : "Copiar link do formulário",
      "openFormLink" : "Abrir link do formulário",
      "invalidInput" : "Entrada inválida!",
      "funnel" : {
        "funnel" : "Funil",
        "chooseStep" : "selecionar uma etapa",
        "copyCodeAndOpenFunnel" : "Copiar Código e Abrir o Funil"
      },
      "share" : {
        "share" : "Compartilhar",
        "shareViaSocials" : "Compartilhar Via redes sociais",
        "copyLink" : "Copiar link"
      },
      "email" : {
        "email" : "E-mail",
        "shareViaEmail" : "Compartilhar por e-mail",
        "emailButton" : "E-mail",
        "blankTemplate" : "Modelo em branco",
        "emailMarketingTemplates" : "Modelos de Marketing E-mail",
        "or" : "Ou",
        "chooseTemplate" : "Escolha entre os seus modelos",
        "continue" : "Continuar"
      }
    },
    "rating" : {
      "icon" : "Ícone",
      "iconAlignment" : "Alinhamento do Ícone",
      "count" : "Contagem",
      "lowestRating" : "Classificação mínima",
      "highestRating" : "Classificação máxima",
      "iconSelectedState" : "Estado Selecionado do Ícone",
      "iconUnselectedState" : "Estado não selecionado do Ícone",
      "rating" : "Classificação",
      "ratingSettings" : "Configurações de classificação",
      "calculationType" : {
        "calculationType" : "Como Arquivar Campos de classificação in Personalizado Campos",
        "calculationTypeTooltip" : "Quando Você Frequência algo 4 de 5 estrelas, significa: - Total: 4 de 5 - Porcentagem: 80 - Fração: 0,8",
        "absolute" : "Total",
        "percentage" : "Porcentagem",
        "fraction" : "Fração"
      }
    },
    "desktopMode" : "Modo de desktop",
    "mobileMode" : "Modo móvel",
    "versions" : "Variantes",
    "advanced" : "Avançado",
    "edit" : "Editar",
    "settings" : "Configurações",
    "submissions" : "Envios",
    "undo" : "Desfazer",
    "redo" : "Refazer",
    "customValues" : "Valores personalizados",
    "pickBgFromImage" : "Adiciona um desfoque ao fundo da sua caixa de mensagem. Se você escolher uma cor de fundo para a caixa de mensagem, ela aparecerá sobre a caixa de mensagem desfocada.",
    "pickBgFromImageTip" : "Escolha uma Cor com alto Comparar para a Imagem de fundo. Mensagem: não será aplicado se o Plano de fundo do Formulário não tiver Imagem",
    "messageBackgroundBlur" : "Desfoque do plano de fundo",
    "confirmationMessage" : "Mensagem de confirmação",
    "deleteOption" : "Opções de exclusão",
    "deleteConfirmationModal" : {
      "defaultDescription" : "Excluir uma opção afetará este campo personalizado em todos os Assentos em que o campo for usado. Tem certeza de que deseja excluir isso?",
      "validationMessage" : "Insira a exclusão para salvar.",
      "validationError" : "Insira a exclusão"
    },
    "disqualifyImmediately" : "Desqualificar imediatamente",
    "disqualifyAfterSubmit" : "Desqualificar após o envio",
    "generalSettings" : "Configurações Geral",
    "advancedSettings" : "Configurações avançadas",
    "customFieldName" : "Personalizado Nome do Setor",
    "customFieldNameTooltip" : "Este nome de Setor é único por Personalizado Setor.",
    "uniqueKey" : "Chave exclusiva",
    "uniqueKeyTooltip" : "Este Chave é exclusivo por Personalizado Setor.",
    "selectContactAssociation" : "Selecione a relação com Contatos",
    "associations" : "Associações",
    "createNewAssociation" : "Criar nova relação",
    "selectAnAssociation" : "Selecione uma relação",
    "loadingAssociations" : "Carregando associações...",
    "unknownAssociation" : "Relação Anônimo",
    "manyToMany" : "Muitos para muitos",
    "failedToLoadAssociations" : "Falha ao carregar as associações",
    "noAssociationsFound" : "Nenhuma associação encontrada",
    "keepThisField" : "Manter este campo",
    "association" : "Associação",
    "customObject" : "Objeto personalizado",
    "customObjects" : "Objetos personalizados",
    "object" : "Objeto",
    "editAssociation" : "Editar relação de {objectName}",
    "editAssociationButton" : "{edit} {objectName} {association}",
    "fields" : "Campos",
    "primaryFieldWarning" : "{fieldName} é um Setor PRINCIPAL para {objectSingular} e é Obrigatório para criar Ou Atualizar um {objectSingular}.",
    "primaryFieldTitle" : "{fieldName} é Obrigatório para criar ou Atualizar o Documento {objectSingular}.",
    "removeAllFields" : "Remover todos os campos {objectSingular}",
    "customObjectsFallback" : "Objetos personalizados",
    "noneAssociation" : "Nenhum",
    "noneAssociationDescription" : "Nenhuma relação com Contatos (sem Campos de Contato aqui)",
    "survey" : {
      "layoutType" : "Tipo de Pesquisa",
      "oneQuestionPerPage" : "Uma pergunta de cada vez",
      "allQuestionsOnePage" : "Muitos de uma vez"
    },
    "quizQuestions" : "Questionário de consulta",
    "choiceElements" : "Componentes de escolha",
    "otherElements" : "Outros componentes",
    "listEditor" : {
      "prefillValueHeader" : "Valor de Preencher automaticamente",
      "labelPlaceholder" : "Rótulo",
      "valuePlaceholder" : "Valor",
      "optionRequiredError" : "A opção Campo é Obrigatório"
    },
    "field" : "Campo",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Adicionar Campo",
      "fieldLabel" : "Campo",
      "numberLabel" : "número"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Tipos de Arquivo",
      "all" : "todos",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/ JPEG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok": "OK",
    "allowMultipleFiles": "Habilitar vários arquivos",
    "maxFileLimit": "Limite Máximo de Arquivo",
    "privacyPolicy": "Declaração de privacidade",
    "termsOfService": "Termos de Serviço",
    "billingFrequency": "Frequência de faturamento",
    "otherAmount": "Outro valor",
    "exampleUrlPlaceholder": "https://www.exemplo.com",
    "checkboxStyles": {
      "standardAlt": "Estilo padrão da caixa de seleção",
      "bubbleAlt": "Estilo de caixa de seleção em forma de bolha"
    },
    "previewIcons" : {
      "exportAlt" : "Ícone de exportação",
      "shipmentAlt" : "Ícone de envio",
      "resultAlt" : "Ícone da página de resultados"
    },
    "examples" : {
      "sampleUrl" : "https://exemplo.com"
    },
    "showing": "Exibindo",
    "of": "de",
    "enterCouponCode": "Insira o código do cupom",
    "apply": "Aplicar",
    "paymentWillBeProcessed": "O pagamento será processado assim que você prosseguir para a próxima etapa",
    "paymentWillBeProcessedNextSlide": "O pagamento será processado assim que o usuário prosseguir para o próximo slide",
    "showThisAlertToUsers": "Mostrar este alerta aos usuários",
    "sixteenDigitCardNumber": "Número do cartão com 16 dígitos",
    "mmYy": "MM/AA",
    "cvc": "CVC",
    "pleaseFillRequiredFields": "Preencha todos os campos obrigatórios!",
    "opportunitySettingsIncomplete": "Configurações de oportunidade estão incompletas",
    "opportunitySettingsIncompleteDescription": "Este formulário inclui campos de oportunidade, mas as configurações de oportunidade não foram atualizadas. Por favor, configure as definições da Oportunidade para prosseguir com o salvamento do formulário.",
    "ariaAttributes": {
      "iconSearch": "Pesquisa por ícone"
    },
    "alt": {
      "standardRadioStyle": "Estilo de botão de opção padrão",
      "bubbleRadioStyle": "Estilo de botão tipo bolha"
    },
    "value": "Valor",
    "jumpTo": "Pular para",
    "thankYouJohnDoe": "Obrigado, João Silva",
    "total": "Total",
    "urlExamples": {
      "simple": "exemplo.com",
      "https": "https://exemplo.com",
      "withPath": "exemplo.com/caminho",
      "fullPath": "https://www.example.com/path"
    }
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Escolha Indivíduo",
      "multipleChoice" : "Escolha várias",
      "yesNo" : "Sim / Não",
      "shortAnswer" : "Curto Respondedo",
      "longAnswer" : "Resposta longo",
      "number" : "número",
      "singleDropdown" : "Indivíduo Lista suspensa",
      "multiDropdown" : "Lista suspensa de vários"
    },
    "personal" : {
      "fullName" : "Nome Completo",
      "firstName" : "Nome",
      "lastName" : "último Nome",
      "dateOfBirth" : "Data de nascimento",
      "phone" : "Telefone",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Botão"
    },
    "integration" : {
      "sellProducts" : "Vender produtos",
      "collectPayment" : "Coletar pagamento"
    },
    "address" : {
      "address" : "Endereço",
      "streetAddress" : "Endereço",
      "city" : "Cidade",
      "state" : "Estado",
      "country" : "País",
      "postalCode" : "Código postal",
      "organization" : "Grupo",
      "website" : "Website",
      "websitePlaceholder" : "O URL da web fica aqui"
    },
    "text" : {
      "singleLine" : "Indivíduo Linha a",
      "multiLine" : "Vários Linha",
      "textBoxList" : "Texto Quadrado Lista"
    },
    "choiceElements" : {
      "singleDropdown" : "Indivíduo Lista suspensa",
      "multiDropdown" : "Lista suspensa de vários",
      "checkbox" : "Caixa de seleção",
      "radio" : "Botão de opção"
    },
    "customized" : {
      "text" : "Clique para editar este texto",
      "html" : "HTML",
      "htmlPlaceholder" : "O HTML Personalizado fica aqui",
      "captcha" : "Legenda",
      "source" : "Fonte",
      "termsAndConditions" : "T e C",
      "termsAndConditionsPlaceholder" : "Concordo com os termos e condições Emmitido Via a empresa. Ao fornecer minha número de telefone, concorda com as mensagens Herdar Texto De a empresa.",
      "score" : "Pontuação"
    },
    "other" : {
      "image" : "Imagem",
      "fileUpload" : "Carregar de Arquivo",
      "monetary" : "Monetário",
      "number" : "número",
      "datePicker" : "Seletor de Data",
      "signature" : "Assinatura"
    },
    "customstyle" : "Estilo",
    "standard" : "Padrão",
    "bubble" : "Bubble"
  },
  "survey": {
    "typeOfBuilder": "Pesquisa",
    "survyeStyle": "Estilo da pesquisa",
    "surveyName": "Nome da pesquisa",
    "surveyElement": "Elemento da pesquisa",
    "addSurveyElement": "Adicionar elemento de pesquisa",
    "cloneSlide": "Clonar slide",
    "unsavedAlertMessage": "A pesquisa tem trabalho não salvo. Tem certeza de que deseja sair e descartar todo o trabalho não salvo?",
    "thirdPartyScriptAlertMessage": "Scripts de terceiros dentro do bloco HTML podem fornecer uma funcionalidade poderosa, mas também trazem riscos à privacidade, segurança, desempenho e comportamento da página. Portanto, recomendamos que você revise o conteúdo desse script antes de salvá-lo no questionário.",
    "integrateHeader": "Integrar pesquisa",
    "integrateSubHeader": "Use as seguintes opções para integrar o questionário personalizado ao seu site",
    "integrateCopyLinkMessage": "Copie o link abaixo e compartilhe-o facilmente em qualquer lugar.",
    "onSurveySubmission": "No envio da pesquisa",
    "surveySettings": "Configurações da pesquisa",
    "oneQuestionAtTime": "Uma pergunta de cada vez",
    "backButton": "Botão Voltar",
    "backButtonTooltipMessage": "O botão Voltar ajudará os usuários a voltar para o slide anterior",
    "disableAutoNavigation": "Desativar navegação automática",
    "disableAutoNavigationTooltipMessage": "Navega automaticamente para o Próximo Deslizar Depois que um usuário responder.",
    "autoNavigation": "Navegação Automático",
    "autoNavigationTooltipMessage": "Navega automaticamente para o Próximo Deslizar Depois que um usuário responder.",
    "progressBar": "Barra de progresso",
    "progressBarTooltipMessage": "Desativar essa opção removerá a barra de progresso da pesquisa.",
    "disableAnimation": "Desativar animação",
    "disableAnimationTooltipMessage": "Ativar essa opção desativará a animação da transição de slides",
    "scrollToTop": "Rolar até o topo",
    "scrollToTopTooltipMessage": "Se ativada, a pesquisa será rolada para o topo no próximo slide",
    "submitSurvey": "Enviar Pesquisa",
    "disqualifyImmediately": "Desqualificar imediatamente",
    "disqualifyAfterSubmit": "Desqualificar após o envio",
    "disqualifyAfterSubmitLowerCase": "Desqualifique após o envio",
    "footerHTML": "Rodapé HTML",
    "footerHTMLMessage": "Você pode escrever CSS personalizado (usando tag de estilo) e HTML dentro da mesma caixa",
    "editFooter": "Editar rodapé",
    "disqualifySettings": "Configurações de desqualificação",
    "disqualifyImmediatelyLabel": "Imediatamente",
    "disqualifyAfterSubmitLabel": "Após o envio",
    "slideConflictAlertMessage": "Este slide contém várias perguntas com uma lógica definida. Isso pode causar comportamento não intencional",
    "addSlide": "Adicionar slide",
    "settings": "Configurações",
    "delete": "Excluir",
    "slideDeleteAlertMessage": "Tem certeza de que deseja excluir este slide?",
    "slideDeleteBetweenAlertMessage": "Isso reorganizará os outros slides. Tem certeza de que deseja excluir este slide?",
    "slideLabel": "Slide {n}",
    "slideName": "Nome do slide",
    "slidePosition": "Posição do slide",
    "jumpTo": "Pular para",
    "jumpToSubText": "Vá para um slide específico",
    "enableTimezoneSurvey": "A ativação dessa opção capturará as informações de fuso horário da pessoa que está enviando a pesquisa",
    "footer": {
      "footer": "Rodapé",
      "enableNewFooter": "Ativar novo rodapé",
      "stickToSurvey": " Participe da pesquisa",
      "backgroundFill": "Preenchimento do plano de fundo",
      "footerHeight": "Altura do rodapé",
      "enableProgressBar": "Ativar barra de progresso",
      "buttons": "Botões",
      "button": "Botão",
      "buttonType": "Tipo de botão",
      "fillNext": "Preencher (próximo)",
      "fillPrevious": "Preenchimento (anterior)",
      "fillSubmit": "Preencher (Enviar)",
      "textColor": "Texto do botão",
      "position": "Posição",
      "previousText": "Anterior (texto)",
      "nextText": "Próximo (texto)",
      "submitText": "Enviar (texto)",
      "fillComplete": "Preenchimento concluído",
      "fillInactive": "Preenchimento inativo",
      "footerType": "Tipo de rodapé",
      "stickToCard": "Ficar no cartão",
      "stickToPage": "Ficar na página",
      "stepTextColor": "Cor da Etapa Corpo",
      "progressBarFill": "Preencher da Barra de progresso",
      "progressBarInactive": "Barra de progresso Inativo",
      "arrowFill": "Preencher de Seta",
      "submitColorMobile": "Enviar (Cor)",
      "arrowFillColor": "Cor de Preencher da Seta",
      "buttonTypes": {
        "textAndArrow": "Texto & Seta",
        "onlyText": "Apenas texto",
        "onlyArrow": "Apenas Seta"
      },
      "positions" : {
        "leftAndRight" : "Esquerda e direita"
      },
      "placeholders" : {
        "prev" : "Anterior",
        "next" : "Próximo",
        "submit" : "Enviar"
      }
    },
    "surveyNotfication" : "Notificação de pesquisa",
    "style" : {
      "surveyPadding" : "Preenchimento de pesquisa"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Incorporar ou Compartilhar Pesquisa",
      "share" : {
        "openFormLink" : "Abrir Link de Pesquisa"
      },
      "email" : {
        "emailSubheader" : "Crie um e-mail em branco e incorporar sua pesquisa, Ou selecionar um modelo e incorporar imediatamente."
      }
    },
    "autoResponderSubheader": "Envie um e-mail automático para a pessoa que enviar o questionário (o e-mail inclui uma cópia das informações inseridas no questionário)",
    "sendSubmissionsAsPdf": "Enviar o questionário em formato PDF",
    "switchToOneQuestionAtTimeOn": "Habilitar ' One Pergunta em a Data' interrompe sua Lógica condicional Atual",
    "switchToOneQuestionAtTimeOff": "Desabilitar ' One Pergunta em a Data' afetará sua configuração de lógica condicional",
    "switchToOneQuestionAtTimeOnWarning": "Algumas condições não funcionarão mais como esperado Quando as perguntas são Comparadas um em um dado.",
    "switchToOneQuestionAtTimeOffWarning": " Algumas condições projetadas para o Fluxo da pergunta Indivíduo deixarão de funcionar conforme o esperado.",
    "createContactOnPartialSubmissionSubText": "Cria um contato quando um usuário clica em \"Próximo\" em qualquer slide, mesmo que não termine a pesquisa.",
    "dragDrop": {
      "imageLabel": "Imagem {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Pesquisa {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Política de Privacidade</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Termos de Serviço</a></p>",
      "smsConsent": "Eu concordo em receber notificações SMS, alertas e comunicações de marketing ocasionais da empresa. A frequência das mensagens varia. Podem ser aplicadas taxas de mensagens e dados. Envie HELP para (XXX) XXX-XXXX para obter assistência. Responda STOP para cancelar a assinatura a qualquer momento."
    }
  },
  "form" : {
    "typeOfBuilder" : "Formulário",
    "formStyle" : "Estilo do formulário",
    "formElement" : "Elemento do formulário",
    "addFormElement" : "Adicionar elemento do formulário",
    "addConditionalLogic" : "Adicionar lógica condicional",
    "openConditionalLogic" : "Abrir lógica condicional",
    "inlineForm" : "Formulário em linha",
    "formName" : "Nome do formulário",
    "fullScreenMode" : "Modo de tela cheia",
    "fullScreenModetooltip" : "Ativá-lo fará com que o formulário se expanda por toda a largura do contêiner, estendendo-se até a borda da área de incorporação e aderindo à largura do formulário.",
    "enableTimezoneForm" : "A ativação dessa opção capturará as informações de fuso horário da pessoa que está enviando o formulário",
    "formSettings" : "Configurações do formulário",
    "unsavedAlertMessage" : "O formulário tem trabalho não salvo. Tem certeza de que deseja sair e descartar todo o trabalho não salvo?",
    "thirdPartyScriptAlertMessage" : "Scripts de terceiros dentro do bloco HTML podem fornecer uma funcionalidade poderosa, mas também trazem riscos à privacidade, segurança, desempenho e comportamento da página. Portanto, recomendamos que você revise o conteúdo desse script antes de salvá-lo no formulário.",
    "onFormSubmission" : "No envio do formulário",
    "integrateForm" : "Formulário de integração",
    "embedlayoutType" : "Incorporar Digitar de Layout",
    "embedlayoutTypeSubMessage" : "Selecione um layout para incorporar em um funil ou site externo",
    "triggerType" : "Tipo de gatilho",
    "showOnScrolling" : "Mostrar na rolagem",
    "showAfter" : "Exibir após",
    "seconds" : "segundos",
    "alwaysShow" : "Sempre mostrar",
    "activationOptions" : "Opções de ativação",
    "activateOn" : "Ativar em",
    "visit" : "visitar",
    "alwaysActivated" : "Sempre ativado",
    "deactivationOptions" : "Opções de desativação",
    "deactivateAfterShowing" : "Desativar após mostrar",
    "times" : "vezes",
    "deactiveOnceLeadCollected" : "Desativar assim que o lead for coletado",
    "neverDeactivate" : "Nunca desativar",
    "copyEmbedCode" : "Copiar código de incorporação",
    "copyFormLink" : "Copiar link do formulário",
    "openFormLink" : "Abrir link do formulário",
    "inline" : "Em linha",
    "inlineDescription" : "Um formulário em linha aparece com o conteúdo da página como um elemento nativo. Ele não se sobrepõe e não pode ser fechado ou minimizado.",
    "inlineHoverDescription" : "Um formulário em linha aparece com o conteúdo da página como um elemento nativo. Ele não se sobrepõe e não pode ser fechado ou minimizado.",
    "popup" : "Pop-up",
    "popupDescription" : "Um pop-up mostra o formulário como uma sobreposição dentro de uma caixa iluminada. Pode ser fechado, mas não minimizado.",
    "popupHoverDescription" : "Um pop-up mostra o formulário como uma sobreposição dentro de uma caixa iluminada. Pode ser fechado, mas não minimizado.",
    "politeSlideIn" : "Formulário deslizante",
    "politeSlideInDescription" : "Um slide discreto aparece na parte inferior da tela e desaparece quando fechado",
    "politeSlideInHoverDescription" : "Aparece na parte inferior da tela e desaparece quando fechada",
    "stickySidebar" : "Barra lateral fixa",
    "stickySidebarDescription" : "Uma barra lateral fixa será exibida na lateral da tela e poderá ser minimizada em uma aba que fica na lateral da janela",
    "stickySidebarHoverDescription" : "Aparece na lateral da tela e pode ser minimizada em uma aba que fica na lateral da janela",
    "allowMinimize" : "Permitir minimizar",
    "conditonalLogic" : {
      "conditions" : "Condições",
      "noExistingCondition" : "Ainda não há condições existentes",
      "freeRoamMessage" : "Você está livre para se movimentar sem regras, pelo menos por enquanto.",
      "addNewCondition" : "Adicionar nova condição",
      "redirectToUrl" : "Redirecionar para URL",
      "displayCustomMessage" : "Exibir mensagem personalizada",
      "disqualifyLead" : "Desqualificar lead",
      "showHideFields" : "Mostrar/Ocultar Campos",
      "jumpTo" : "Pular para",
      "redirectToUrlSubText" : "Redirecionar usuário após o envio",
      "displayCustomMessageSubText" : "Exibir mensagens com base em entradas de usuário ativado",
      "disqualifyLeadSubText" : "Filtrar entradas sob condições específicas",
      "showHideFieldsSubText" : "Modificar o campo Visibilidade dinammente",
      "openBelowUrl" : "Abrir a URL abaixo",
      "showCustomMessage" : "Mostrar mensagem personalizada",
      "alertConditionDelete" : "Tem certeza de que deseja excluir esta condição?",
      "deleteCondition" : "Excluir condição",
      "conditionExecutedMessage" : "As condições serão executadas de cima para baixo.",
      "allOperationOptions" : {
        "isEqualTo" : "É igual a",
        "isNotEqualTo" : "Não é igual a",
        "contains" : "Contém",
        "doesNotContain" : "Não contém",
        "startsWith" : "Começa com",
        "endsWith" : "Termina com",
        "isEmpty" : "Está vazio",
        "isFilled" : "É preenchido",
        "before" : "Antes",
        "after" : "Depois",
        "greaterThan" : "Maior que",
        "lessThan" : "Menor que",
        "between" : "Entre",
        "isChecked" : "Está marcado",
        "isNotChecked" : "Não está marcado"
      },
      "logic" : {
        "if" : "Se",
        "then" : "Então",
        "and" : "E",
        "or" : "Ou"
      },
      "phoneAlertMessage" : "Para pesquisar números de telefone com um código de país, você precisa incluir o símbolo \"+\" em sua consulta de pesquisa.",
      "deleteAlertMessage" : "Tem certeza de que deseja excluir este campo? A condição associada a este campo também será removida.",
      "deleteField" : "Excluir campo",
      "jumpToDescription" : "Vá para um slide específico quando as condições forem satisfeitas",
      "cycleError" : "Não é possível salvar. Ciclo detectado entre {a} e {b}",
      "jumpToSlide" : "Pular para slide",
      "submitSurvey" : "Enviar Pesquisa",
      "pageTitle" : "P{index} - {title}",
      "selectSlideToJumpTo" : "Selecionar Deslizar para pular De",
      "selectedSlide" : "Slide selecionado",
      "typeValueHere" : "Digite um valor aqui",
      "field" : "Campo",
      "slide" : "Deslizar",
      "selectFieldOrSlide" : "Selecionar campo ou slide",
      "selectFieldState" : "Selecionar estado do campo",
      "selectField" : "Selecione o campo",
      "selectOption" : "Selecione a opção",
      "jumpToTarget" : "Pular para",
      "jumpToQuestion" : "Ir para a Pergunta",
      "chooseQuestion" : "Selecionar pergunta",
      "includeStart" : "Incluir início",
      "includeEnd" : "Incluir Fim",
      "includeValue" : "Incluir {value}",
      "hideField" : "Ocultar campo",
      "hideFields" : "Ocultar Campos",
      "showField" : "Exibir campo",
      "showFields" : "Exibir Campos",
      "additionalRulesPrefix" : "... e",
      "additionalRulesSuffix" : "outras regras {ifLabel}...",
      "shownTargetsWithMore" : "{shown}, +{count} adicionais",
      "noConditionsAlt" : "Ainda não há condições",
      "outcomeLabels" : {
        "show" : "Exibir",
        "jumpTo" : "Pular para"
      }
    },
    "minimizedTitlePlaceholder": "Título minimizado",
    "dragYourElementFromLeft": "Arraste seus elementos aqui a partir da esquerda",
    "formNotification": "Notificação de formulário",
    "sendSubmissionsAsPdf": "Enviar formulário em formato PDF",
    "style": {
      "formPadding": "Preenchimento de formulário"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Incorporar ou Compartilhar Formulário",
      "share" : {
        "openFormLink" : "Abrir Link do Formulário"
      },
      "email" : {
        "emailSubheader" : "Crie um e-mail em branco e incorporar seu formulário, Ou selecionar um modelo e incorporar imediatamente."
      }
    },
    "choosePosition": "Selecionar Status",
    "testBuild": "Testar versão"
  },
  "quiz" : {
    "quizElement" : "Elemento do questionário",
    "quizNotification" : "Notificação de questionário",
    "viewAndCustomise" : "Ver e personalizar",
    "categoryAndScore" : "Categoria e Pontuação",
    "provideFeedback" : "Dar feedback",
    "addQuizElement" : "Adicionar elemento de teste",
    "typeOfBuilder" : "Questionário",
    "addQuestions" : "Adicionar perguntas",
    "dragAndDropQuestion" : "Arrastar e solte um elemento de Pergunta aqui.",
    "addNewPage" : "Adicionar nova página",
    "editTemplate" : "Editar Modelo",
    "editResultPage" : "Editar página de resultados",
    "clonePage" : "Clonar página",
    "category" : {
      "category" : "Categoria",
      "watchVideo" : "Assista a este vídeo para saber mais sobre como a categoria afetam a página de resultados!",
      "useCategoryWhen" : "Usar categorias Quando",
      "manageCategories" : "Gerenciar Categorias",
      "howItWorks" : "Como isso funciona 🎉",
      "howItWorks2" : "Como isso funciona",
      "addCategoryMessage" : "Adicionar uma nova categoria",
      "assignCategoryMessage" : "Atribuir uma categoria a todos a opção",
      "editResultsMessage" : "Exibir pontuação de categoria in página de resultado",
      "addCategory" : "Adicionar Categoria",
      "deleteCategoryAlertMessage" : "Apagar uma categoria resultará no restante dessa categoria in todas as opções",
      "editOrAddNewCategories" : "Você pode editar ou incluir novas categorias",
      "toEvaluateTheResponder" : "Para Comparar a resposta com base Ativado vários fatores",
      "showMultipleCategoryScore" : "Exibir várias pontuação de Categoria in Página de Resultado",
      "displayVaryingContent" : "Exibição variante de conteúdo Ativado os resultados Página de acordo com Ativado o nível de pontuação Categoria",
      "theOptionFieldIsRequired" : "O campo de opções é obrigatório",
      "addManage" : "Adicionar / Gerenciar",
      "enterCategoryPlaceholder" : "Insira o nome da categoria",
      "carouselAlt" : "Slide de visualização da categoria"
    },
    "quizSettings" : "Configurações do Quiz",
    "onQuizSubmission" : "No envio do questionário",
    "settings" : "Configurações",
    "deletePage" : "Excluir página",
    "quizResult" : {
      "resultTemplate" : "Modelo de resultado",
      "quizResultAlertMessage" : "A página de resultados escolhida será exibida assim que o questionário for concluído",
      "overallScoreLabel" : "Pontuação geral"
    },
    "autoResponderSubheader": "Envie um e-mail automático para a pessoa que enviar o questionário (o e-mail inclui uma cópia das informações inseridas no questionário)",
    "sendSubmissionsAsPdf": "Enviar o questionário em formato PDF",
    "sendQuizResultsAsPdf": "Enviar resultado do questionário como PDF",
    "integrateHeader": "Integrar questionário",
    "integrateSubHeader": "Use as seguintes opções para integrar o questionário personalizado ao seu site",
    "integrateCopyLinkMessage": "Copie o link abaixo e compartilhe-o facilmente em qualquer lugar.",
    "pageLabel": "Página {n}",
    "pageName": "Nome da página",
    "pagePosition": "Posição da página",
    "createContactOnPartialSubmissionSubText": "Cria um contato quando um usuário clica em \"Próximo\" em qualquer slide, mesmo que ele não conclua o Quiz.",
    "integratePopup": {
      "shareOrEmbed": "Incorporar ou Compartilhar Questionário",
      "share": {
        "openFormLink": "Abrir Link do questionário"
      },
      "email" : {
        "emailSubheader" : "Crie um e-mail em branco e incorporar seu questionário, Ou selecionar um modelo e incorporar imediatamente."
      }
    }
  },
  "textEditor": {
    "textAlign": "Alinhamento de texto",
    "list": "Lista",
    "sourceCode": "Código-fonte",
    "resetStyle": "Redefinir estilo",
    "resetDocumentStyle": "Redefinir estilo do documento"
  }
}
